import React from "react";
import {IconButton, colors} from "@material-ui/core";
import PlusIcon from "@material-ui/icons/AddCircle";

interface NewQueryButtonProps {
  onNewChat: () => void;
  compact?: boolean;
}

export function NewQueryButton({onNewChat, compact}: NewQueryButtonProps) {
  return (
    <IconButton
      title="Make a new query"
      edge="start"
      color="inherit"
      size={compact ? "small" : "medium"}
      onClick={onNewChat}
    >
      <PlusIcon style={{color: colors.blue[200]}} />
    </IconButton>
  );
}
